<template>
    <div class="container" id="about">
        <div class="mission">
            <img src="../assets/growth.svg" alt="">
            <p>Here at Shabeb, our <span>mission</span> is to help you <span>grow</span> your <span>business</span> one delivery at a time. We're here to take away the stress of making sure your deliveries arrive both on <span>time</span> and in <span>good condition</span>. The best part is that you'll immediately notice <span>savings</span> when you switch to our <span>solutions</span>.</p>
        </div>
        <div class="content">
            <h1>Why join us?</h1>
            <div class='info-cont'>
                <Info title="Convenient Pick up & Delivery" description="Get your goods where they need to go with the least hassle possible." />
                <Info title="Live Order Tracking" description="Track your orders as they explore the roads with us and reach their destination." />
                <Info title="24/7 Support & Service" description="Our services are available 24/7 and our customer support office is always ready to answer your call." />
            </div>
        </div>
    </div>
</template>

<script>

    import Info from './Info.vue'

    export default {
        name: 'Why',
        components:{
            Info,
        }
    }
</script>

<style scoped>
    .container{
        position: relative;
        min-height: 100vh;
        height: fit-content;
        width: 100%;
        background: var(--background);
        color: var(--accent);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 4rem 20%;

    }
    .mission{
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 4rem 10rem;
        background: var(--color-primary);
        border-radius: 4rem;
        color: var(--background);
        margin-top: 10rem;
        margin-bottom: 10rem;
    }
    .mission img{
        width: 50rem;
    }
    .mission p{
        font-size: 2.4rem;
        font-weight: 500;
        width: 50rem;
        text-align: justify;
        letter-spacing: .3rem;
        line-height: 1.6;
    }
    .mission p span{
        color: #3a6fe6;
    }
    .content{
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .content>h1{
        font-size: 4rem;
        /* color: var(--color-primary); */
        color: var(--accent);
        font-weight: 400;
        margin-bottom: 10rem;
    }
    .content .info-cont{
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    @media screen and (max-width:1200px) and (min-width:993px){
        .container{
            padding: 4rem 4rem;
        }
    }
    @media screen and (max-width:992px) and (min-width:769px) {
        .container{
            padding: 4rem 2rem;
        }
        .mission{
            flex-direction: column;
        }
    }
    @media screen and (max-width:768px) and (min-width:480px){
        .container{
            padding: 4rem 0rem;
        }
        .mission{
            flex-direction: column;
            padding: 2rem;
        }
        .mission p{
            width: unset;
        }
        .info-cont{
            flex-direction: column;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
        }
    }
    @media screen and (max-width:479px){
        .container{
            padding: 4rem 0rem;
        }
        .mission{
            flex-direction: column;
            padding: 2rem;
        }
        .mission img{
            width: 100%;

        }
        .mission p{
            width: unset;
        }
        .info-cont{
            flex-direction: column;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
        }
    }
        
    
</style>